const KeyMirror = require('keymirror');

module.exports = KeyMirror({
    SAVE_ANSWERS: true,
    SEND_EATA_REQUEST_BEGIN: true,
    SEND_EATA_REQUEST_SUCCESS: true,
    SEND_EATA_REQUEST_ERROR: true,
});
